import { motion } from "framer-motion";

const OurStory = () => {
  return (
    <div className="relative bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 bg-cover px-p83 overflow-hidden" id="story">
      {/* Background accents */}
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-primary-500/8 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-orange/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none" />
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 0% 50%, rgba(0, 120, 209, 0.08), transparent 50%)'
        }}
      />
      
      <div className="grid grid-cols-1 800:grid-cols-2 items-center w-full pt-8 500:pt-12 gap-6 500:gap-8 pb-8 500:pb-12 800:pb-16 justify-between min-h-[90vh] relative z-10">
        <motion.div
          className="text-neutral-300 text-sm 500:text-base"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* Badge */}
          <motion.div
            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-primary-500/20 to-primary-600/10 border border-primary-500/30 rounded-full mb-6 backdrop-blur-sm"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <span className="w-2 h-2 bg-primary-400 rounded-full animate-pulse" />
            <span className="text-primary-300 font-poppins-semibold text-sm">
              About Us
            </span>
          </motion.div>

          <h2 className="text-2xl 500:text-3xl 700:text-4xl font-merry-bold tracking-tight pb-4 text-neutral-100">
            Our <span className="relative inline-block">
              <span className="relative z-10 font-bold text-primary-500">Story</span>
              <motion.span
                className="absolute bottom-1 left-0 right-0 h-2 bg-primary-500/20 -z-0 rounded-full"
                initial={{ width: 0 }}
                whileInView={{ width: "100%" }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
            </span>
          </h2>
          
          <div className="space-y-4">
            <p className="font-poppins-regular leading-relaxed text-neutral-300">
              At Nexasoft, our story is one of innovation, determination, and the
              relentless pursuit of excellence. Our team is not just a group of
              professionals; we're a lean, mean machine composed of former startup
              founders and tech evangelists.
            </p>
            <p className="font-poppins-regular leading-relaxed text-neutral-300">
              We've walked the entrepreneurial path, understanding the challenges
              and opportunities it presents. In the ever-evolving tech landscape,
              we firmly believe that innovation and harnessing the best talent are
              not optional but imperative. We've experienced firsthand the
              difficulties of nurturing and growing a startup, from taking it from
              ground zero to scaling it to new heights.
            </p>
          </div>
        </motion.div>
        
        <motion.div
          className="relative"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {/* Decorative glow behind image */}
          <div className="absolute inset-0 bg-primary-500/10 rounded-3xl blur-2xl opacity-50" />
          
          <motion.div
            className="relative"
            animate={{
              y: [0, -20, 0],
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <motion.img
              src="Images/ourStoryImg.svg"
              alt="Nexasoft Infotech Team - Software Development Company Story"
              className="width__resp drop-shadow-2xl relative z-10"
              loading="lazy"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
            
            {/* Gradient overlay on image */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary-500/5 via-transparent to-transparent rounded-3xl pointer-events-none" />
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default OurStory;
